import React, { useRef } from 'react';

import { BentoStreamContext } from '@/contexts/BentoStreamContext';
import useWebSocket from '@/hooks/useBentoStream/useWebSocket';
import { RoomConnection } from '@/types/bentoStream';

type Props = { children: React.ReactNode };

export const BentoStreamContextProvider = ({ children }: Props) => {
  const webSocket = useWebSocket();
  const roomConnectionRef = useRef<RoomConnection>(webSocket);

  const createRoomConnection = async (billId: string): Promise<void> => {
    try {
      await roomConnectionRef.current.connect(billId);
    } catch (error) {
      throw error;
    }
  };

  const disconnectFromRoom = (): void => {
    if (roomConnectionRef.current) {
      roomConnectionRef.current.disconnect();
    }
  };

  const subscribeToEvent = (
    channel: string,
    onEvent: (data: Object) => void
  ): void => {
    if (roomConnectionRef.current) {
      roomConnectionRef.current.subscribe(channel, onEvent);
    }
  };

  return (
    <BentoStreamContext.Provider
      value={{
        context: {},
        createRoomConnection,
        disconnectFromRoom,
        subscribeToEvent
      }}
    >
      {children}
    </BentoStreamContext.Provider>
  );
};

export default BentoStreamContextProvider;
